import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material'
import { Tooltip } from '@mui/material'

const QuickAccessCard = ({
  title,
  description,
  infoText,
  icon: IconComponent,
  tone = 'default',
  disabled = false,
  active = false,
  onClick
}) => {
  const tooltipText = infoText || description || title
  const baseCardClass =
    'border-slate-200 bg-white shadow-[0_4px_10px_rgba(15,23,42,0.10)] hover:border-slate-300 hover:shadow-[0_8px_18px_rgba(15,23,42,0.12)]'
  const activeCardClass =
    tone === 'amber'
      ? 'border-amber-300 bg-white ring-1 ring-amber-200 shadow-[0_8px_18px_rgba(146,64,14,0.14)]'
      : 'border-accent2/40 bg-white ring-1 ring-accent2/20 shadow-[0_8px_18px_rgba(28,178,175,0.12)]'
  const iconClass =
    tone === 'amber'
      ? active
        ? 'text-amber-500'
        : 'text-[#9eb1c9]'
      : active
        ? 'text-[#8ca4c2]'
        : 'text-[#a9b7cb]'

  return (
    <button
      type='button'
      onClick={onClick}
      disabled={disabled}
      className={`group relative flex h-[104px] w-[104px] min-w-[104px] max-w-[104px] flex-col items-center justify-center rounded-xl border p-2 text-center transition ${
        disabled
          ? 'cursor-not-allowed border-slate-200 bg-white text-slate-300 opacity-60 shadow-[0_4px_10px_rgba(15,23,42,0.06)]'
          : active
            ? activeCardClass
            : baseCardClass
      }`}
    >
      {tooltipText && (
        <Tooltip title={tooltipText} arrow placement='top'>
          <span
            className='absolute right-1 top-1 z-10 inline-flex cursor-help items-center text-slate-400 transition hover:text-slate-500'
            onClick={event => event.stopPropagation()}
            onMouseDown={event => event.stopPropagation()}
          >
            <InfoOutlinedIcon style={{ fontSize: '0.95rem' }} />
          </span>
        </Tooltip>
      )}

      {IconComponent && (
        <IconComponent
          className={disabled ? 'text-slate-300' : iconClass}
          style={{ fontSize: '2.75rem' }}
        />
      )}

      <h3 className={`mt-1.5 line-clamp-2 px-1 text-[9px] font-semibold font-sans leading-tight ${disabled ? 'text-slate-400' : 'text-slate-900'}`}>
        {title}
      </h3>
    </button>
  )
}

export default QuickAccessCard
